const normalizeIsbn = (value) => String(value ?? '').replace(/[\s-]/g, '').toUpperCase();

const isValidIsbn = (value, length) => {
  if (String(value ?? '').trim() === '') return true;
  const isbn = normalizeIsbn(value);
  return /^[A-Z0-9]+$/.test(isbn) && isbn.length <= length;
};

// Only standard ISBN10 values can be converted; custom identifiers stay independent.
const isStandardIsbn = (value, length) => {
  const isbn = normalizeIsbn(value);
  if (length === 10) {
    return /^\d{9}[\dX]$/.test(isbn) && [...isbn].reduce(
      (sum, digit, index) => sum + (digit === 'X' ? 10 : Number(digit)) * (10 - index), 0
    ) % 11 === 0 && isbn !== '0000000000';
  }
  return /^(978|979)\d{10}$/.test(isbn) && [...isbn].reduce(
    (sum, digit, index) => sum + Number(digit) * (index % 2 ? 3 : 1), 0
  ) % 10 === 0;
};

const toIsbn13 = (isbn10) => {
  if (!isStandardIsbn(isbn10, 10)) return null;
  const stem = `978${normalizeIsbn(isbn10).slice(0, 9)}`;
  const sum = [...stem].reduce((total, digit, index) => total + Number(digit) * (index % 2 ? 3 : 1), 0);
  return `${stem}${(10 - sum % 10) % 10}`;
};

const normalizeBookIsbns = (values) => {
  for (const field of ['isbn10', 'isbn13']) {
    const max = field === 'isbn10' ? 10 : 13;
    if (!isValidIsbn(values[field], max)) {
      throw new Error(`${field === 'isbn10' ? 'ISBN-10' : 'ISBN-13'} must contain 1–${max} letters or numbers`);
    }
    const isbn = normalizeIsbn(values[field]);
    values[field] = isbn || null;
  }
  if (values.isbn10 && !values.isbn13) values.isbn13 = toIsbn13(values.isbn10);
  return values;
};

export { normalizeIsbn, isValidIsbn, isStandardIsbn, toIsbn13, normalizeBookIsbns };
